/* global axios */
import ApiClient from './ApiClient';

class SearchAPI extends ApiClient {
  constructor() {
    super('search', { accountScoped: true });
  }

  get({ q }) {
    return axios.get(this.url, {
      params: {
        q,
      },
    });
  }

  contacts({ q }) {
    return axios.get(`${this.url}/contacts`, {
      params: {
        q,
      },
    });
  }

  companies({ q }) {
    return axios.get(`${this.url}/companies`, {
      params: {
        q,
      },
    });
  }

  // `inboxId` opcional: restringe a uma caixa (testador do filtro do bot, #1735).
  // Ausente, o axios nao manda o parametro e a busca global fica como era.
  conversations({ q, inboxId }) {
    return axios.get(`${this.url}/conversations`, {
      params: {
        q,
        inbox_id: inboxId,
      },
    });
  }

  messages({ q }) {
    return axios.get(`${this.url}/messages`, {
      params: {
        q,
      },
    });
  }
}

export default new SearchAPI();
